<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM16.54 15.8502L15.85 16.5402C15.46 16.9302 14.83 16.9302 14.44 16.5402L11.39 13.4902C10.17 13.9202 8.75 13.6602 7.77 12.6802C6.66 11.5702 6.47 9.89018 7.18 8.58018L9.53 10.9302L10.94 9.52018L8.58 7.17018C9.9 6.46018 11.57 6.65018 12.68 7.76018C13.66 8.74018 13.92 10.1602 13.49 11.3802L16.54 14.4302C16.93 14.8202 16.93 15.4602 16.54 15.8502Z"
  />
</template>
